import { io } from "socket.io-client";
import { HOST } from "../constants";

/**
 * Conexión en tiempo real de las notificaciones de Compras
 * (docs/FRONTEND_COMPRAS_NOTIFICACIONES.md §2). Un único socket por pestaña,
 * reutilizado por cualquier componente que quiera escuchar
 * 'compras:notificacion' (por ahora solo NavbarNotificaciones).
 */
let socket = null;

export const getComprasNotificacionSocket = () => {
    const token = sessionStorage.getItem("token");
    if (!token) return null;

    if (socket && socket.connected) return socket;

    if (!socket) {
        socket = io(HOST, {
            auth: { token },
            transports: ["websocket", "polling"],
        });
    }

    if (!socket.connected) {
        socket.auth = { token };
        socket.connect();
    }

    return socket;
};

export const disconnectComprasNotificacionSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};
